module.exports = __webpack_public_path__ + "static/media/ad-slide-01.005856c1.jpg";